/* ==========================================================================
   Tienda 3 — Selladora de bolsas
   Movimiento: apariciones, contadores, escena de sellado atada al scroll,
   parallax, inclinación con el ratón, acordeón, galería y variantes.
   Todo degrada bien: si algo falla, la página se sigue viendo entera.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var suave = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tactil = window.matchMedia('(hover: none)').matches;

  function clamp(v, a, b) {
    return v < a ? a : v > b ? b : v;
  }

  /* Devuelve 0-1 según dónde cae p dentro del tramo [a, b] */
  function tramo(p, a, b) {
    if (b === a) return p >= b ? 1 : 0;
    return clamp((p - a) / (b - a), 0, 1);
  }

  function suavizar(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  /* ------------------------------------------------- red de seguridad */
  /* Si por lo que sea nada se anima, a los 2,5 s se enseña todo. */
  setTimeout(function () {
    var ocultos = document.querySelectorAll('.mt-rv:not(.mt-on), .mt-linea-wrap:not(.mt-on)');
    for (var i = 0; i < ocultos.length; i++) ocultos[i].classList.add('mt-on');
  }, 2500);

  /* ------------------------------------------------------- apariciones */

  function apariciones() {
    var el = document.querySelectorAll('.mt-rv, .mt-linea-wrap');
    if (!el.length) return;

    if (!('IntersectionObserver' in window) || suave) {
      for (var i = 0; i < el.length; i++) el[i].classList.add('mt-on');
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-on');
            obs.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    for (var j = 0; j < el.length; j++) obs.observe(el[j]);
  }

  /* Reparte el retraso entre hermanos marcados con [data-mt-escalonar] */
  function escalonar() {
    var grupos = document.querySelectorAll('[data-mt-escalonar]');
    for (var i = 0; i < grupos.length; i++) {
      var paso = parseInt(grupos[i].getAttribute('data-mt-escalonar'), 10) || 90;
      var hijos = grupos[i].children;
      for (var j = 0; j < hijos.length; j++) {
        hijos[j].style.setProperty('--d', j * paso + 'ms');
      }
    }
  }

  /* -------------------------------------------------------- contadores */

  function contadores() {
    var els = document.querySelectorAll('[data-mt-contar]');
    if (!els.length) return;

    function correr(el) {
      if (el.dataset.mtHecho) return;
      el.dataset.mtHecho = '1';

      var fin = parseFloat(el.getAttribute('data-mt-contar'));
      if (isNaN(fin)) return;
      var dec = parseInt(el.getAttribute('data-mt-dec'), 10) || 0;
      var dur = suave ? 0 : 1500;
      var t0 = null;

      function pintar(v) {
        el.textContent = v.toFixed(dec).replace('.', ',');
      }

      if (!dur) {
        pintar(fin);
        return;
      }

      /* Seguro por si la pestaña se va a segundo plano y se para el reloj */
      var vigilante = setTimeout(function () {
        pintar(fin);
      }, dur + 900);

      function paso(t) {
        if (t0 === null) t0 = t;
        var p = clamp((t - t0) / dur, 0, 1);
        pintar(fin * suavizar(p));
        if (p < 1) {
          requestAnimationFrame(paso);
        } else {
          clearTimeout(vigilante);
        }
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) correr(els[i]);
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            correr(e.target);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    for (var j = 0; j < els.length; j++) obs.observe(els[j]);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      for (var k = 0; k < els.length; k++) {
        var el = els[k];
        if (el.dataset.mtHecho && el.textContent.trim() === '') {
          el.textContent = parseFloat(el.getAttribute('data-mt-contar')).toString();
        }
      }
    });
  }

  /* ------------------------------------------ escena del sellado (scroll) */

  function escena() {
    var pistas = document.querySelectorAll('[data-mt-escena]');
    if (!pistas.length) return;

    var lista = [];
    for (var i = 0; i < pistas.length; i++) {
      var pista = pistas[i];
      lista.push({
        pista: pista,
        fijo: pista.querySelector('.mt-esc__fijo'),
        pasos: pista.querySelectorAll('.mt-esc__paso'),
        barra: pista.querySelector('.mt-esc__barra')
      });
    }

    function pintar() {
      var vh = window.innerHeight;
      for (var i = 0; i < lista.length; i++) {
        var it = lista[i];
        var r = it.pista.getBoundingClientRect();
        var total = r.height - vh;
        var p = total > 0 ? clamp(-r.top / total, 0, 1) : 0;
        var f = it.fijo;
        if (!f) continue;

        /* Fases: 1) bolsa abierta  2) baja la barra y calienta  3) sella
           4) la barra se levanta y deja ver la costura terminada */
        var baja = suavizar(tramo(p, 0.06, 0.42)) - suavizar(tramo(p, 0.78, 0.92)) * 0.92;
        var calor = tramo(p, 0.3, 0.46) * (1 - tramo(p, 0.82, 0.95));
        var sella = suavizar(tramo(p, 0.44, 0.78));
        var abre = 1 - suavizar(tramo(p, 0.44, 0.74));
        var ok = suavizar(tramo(p, 0.8, 0.93));

        f.style.setProperty('--baja', baja.toFixed(3));
        f.style.setProperty('--calor', calor.toFixed(3));
        f.style.setProperty('--sella', sella.toFixed(3));
        f.style.setProperty('--abre', abre.toFixed(3));
        f.style.setProperty('--ok', ok.toFixed(3));

        if (it.barra) it.barra.style.setProperty('--av', p.toFixed(3));

        /* Texto activo */
        var n = it.pasos.length;
        if (n) {
          var idx = clamp(Math.floor(p * n), 0, n - 1);
          for (var j = 0; j < n; j++) {
            it.pasos[j].classList.toggle('mt-on', j === idx);
          }
        }
      }
    }

    if (suave) {
      /* Sin movimiento: se enseña el estado final y el primer texto */
      for (var k = 0; k < lista.length; k++) {
        var f = lista[k].fijo;
        if (f) {
          f.style.setProperty('--baja', '0.08');
          f.style.setProperty('--sella', '1');
          f.style.setProperty('--abre', '0');
          f.style.setProperty('--ok', '1');
        }
        if (lista[k].pasos.length) lista[k].pasos[0].classList.add('mt-on');
      }
      return;
    }

    engancharScroll(pintar);
    pintar();
  }

  /* ------------------------------------------------------------ parallax */

  function parallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || suave) return;

    function pintar() {
      var vh = window.innerHeight;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var fuerza = parseFloat(el.getAttribute('data-mt-parallax')) || 26;
        /* -1 arriba del todo, +1 abajo del todo */
        var c = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        el.style.setProperty('--py', (clamp(c, -1, 1) * fuerza).toFixed(1) + 'px');
      }
    }

    engancharScroll(pintar);
    pintar();
  }

  /* --------------------------------------------- inclinación con el ratón */

  function inclinar() {
    var els = document.querySelectorAll('[data-mt-inclinar]');
    if (!els.length || suave || tactil) return;

    for (var i = 0; i < els.length; i++) {
      (function (el) {
        var zona = el.closest('.mt-hero') || el.parentElement;
        if (!zona) return;
        var raf = null;
        var mx = 0,
          my = 0;

        zona.addEventListener('mousemove', function (e) {
          var r = zona.getBoundingClientRect();
          mx = (e.clientX - r.left) / r.width - 0.5;
          my = (e.clientY - r.top) / r.height - 0.5;
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            var g = parseFloat(el.getAttribute('data-mt-inclinar')) || 9;
            el.style.setProperty('--ry', (mx * g).toFixed(2) + 'deg');
            el.style.setProperty('--rx', (-my * g * 0.62).toFixed(2) + 'deg');
          });
        });

        zona.addEventListener('mouseleave', function () {
          el.style.setProperty('--ry', '0deg');
          el.style.setProperty('--rx', '0deg');
        });
      })(els[i]);
    }
  }

  /* ------------------------------------------------------------- acordeón */

  function acordeon() {
    var bts = document.querySelectorAll('.mt-faq__b');
    for (var i = 0; i < bts.length; i++) {
      bts[i].addEventListener('click', function () {
        var it = this.closest('.mt-faq__it');
        var caja = it.querySelector('.mt-faq__r');
        var abierto = it.classList.contains('mt-abierto');

        /* Cerramos los hermanos para que solo haya uno abierto */
        var hermanos = it.parentElement.querySelectorAll('.mt-faq__it.mt-abierto');
        for (var k = 0; k < hermanos.length; k++) {
          if (hermanos[k] !== it) {
            hermanos[k].classList.remove('mt-abierto');
            hermanos[k].querySelector('.mt-faq__r').style.height = '0px';
            hermanos[k].querySelector('.mt-faq__b').setAttribute('aria-expanded', 'false');
          }
        }

        if (abierto) {
          caja.style.height = '0px';
          it.classList.remove('mt-abierto');
          this.setAttribute('aria-expanded', 'false');
        } else {
          caja.style.height = caja.firstElementChild.offsetHeight + 'px';
          it.classList.add('mt-abierto');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    }
  }

  /* --------------------------------------------------------- cabecera fija */

  function cabecera() {
    var cab = document.querySelector('.mt-cab');
    if (!cab) return;
    function pintar() {
      cab.classList.toggle('mt-pegada', window.scrollY > 8);
    }
    engancharScroll(pintar);
    pintar();
  }

  /* -------------------------------------------------- galería de producto */

  /* Cambia la foto grande y marca la miniatura que toca. Lo usan tanto los
     clics en las miniaturas como el selector de color. */
  function ponerFoto(gal, url) {
    if (!gal || !url) return;

    var grande = gal.querySelector('.mt-gal__gr img');
    var mins = gal.querySelectorAll('.mt-gal__m');

    for (var k = 0; k < mins.length; k++) {
      mins[k].classList.toggle('mt-sel', mins[k].getAttribute('data-url') === url);
    }

    if (!grande || grande.getAttribute('src') === url) return;

    grande.style.opacity = '0';
    var img = new Image();
    img.onload = function () {
      grande.src = url;
      grande.style.opacity = '1';
    };
    img.onerror = function () {
      grande.style.opacity = '1';
    };
    img.src = url;
  }

  function galeria() {
    var gals = document.querySelectorAll('[data-mt-galeria]');
    for (var i = 0; i < gals.length; i++) {
      (function (g) {
        var mins = g.querySelectorAll('.mt-gal__m');
        for (var j = 0; j < mins.length; j++) {
          mins[j].addEventListener('click', function () {
            ponerFoto(g, this.getAttribute('data-url'));
          });
        }
      })(gals[i]);
    }
  }

  /* ------------------------------------------------------------- variantes */

  function variantes() {
    var cajas = document.querySelectorAll('[data-mt-variantes]');
    for (var i = 0; i < cajas.length; i++) {
      (function (caja) {
        var datos;
        try {
          datos = JSON.parse(caja.querySelector('[data-mt-json]').textContent);
        } catch (e) {
          return;
        }
        var idInput = caja.querySelector('[name="id"]');
        /* La galería de este mismo producto, para cambiar la foto al elegir color */
        var zona = caja.closest('.mt-prod') || document;
        var gal = zona.querySelector('[data-mt-galeria]');
        var precio = caja.querySelector('[data-mt-precio]');
        var tach = caja.querySelector('[data-mt-tachado]');
        var boton = caja.querySelector('[data-mt-comprar]');
        var grupos = caja.querySelectorAll('.mt-op');

        function elegidas() {
          var v = [];
          for (var g = 0; g < grupos.length; g++) {
            var sel = grupos[g].querySelector('.mt-op__v.mt-sel');
            v.push(sel ? sel.getAttribute('data-val') : null);
          }
          return v;
        }

        function refrescar() {
          var el = elegidas();
          var encontrada = null;
          for (var k = 0; k < datos.length; k++) {
            var coincide = true;
            for (var o = 0; o < el.length; o++) {
              if (datos[k].opciones[o] !== el[o]) {
                coincide = false;
                break;
              }
            }
            if (coincide) {
              encontrada = datos[k];
              break;
            }
          }
          if (!encontrada) return;
          if (idInput) idInput.value = encontrada.id;
          /* Cada color tiene su foto asignada en Shopify: la enseñamos */
          if (encontrada.imagen) ponerFoto(gal, encontrada.imagen);
          if (precio) precio.textContent = encontrada.precio;
          if (tach) {
            if (encontrada.tachado) {
              tach.textContent = encontrada.tachado;
              tach.style.display = '';
            } else {
              tach.style.display = 'none';
            }
          }
          if (boton) {
            if (encontrada.disponible) {
              boton.disabled = false;
              boton.textContent = boton.getAttribute('data-texto') || 'Añadir a la cesta';
            } else {
              boton.disabled = true;
              boton.textContent = boton.getAttribute('data-agotado') || 'Agotado';
            }
          }
        }

        for (var g = 0; g < grupos.length; g++) {
          var vals = grupos[g].querySelectorAll('.mt-op__v');
          for (var v = 0; v < vals.length; v++) {
            vals[v].addEventListener('click', function () {
              var hermanos = this.parentElement.querySelectorAll('.mt-op__v');
              for (var h = 0; h < hermanos.length; h++) hermanos[h].classList.remove('mt-sel');
              this.classList.add('mt-sel');
              refrescar();
            });
          }
        }
        refrescar();
      })(cajas[i]);
    }
  }

  /* ----------------------------------------------------------- cuenta atrás */

  function cuentaAtras() {
    /* El editor de Shopify recarga secciones y vuelve a llamar a arrancar():
       nos quedamos solo con los relojes que aún no hemos puesto en marcha,
       para no dejar dos intervalos corriendo a la vez. */
    var todos = document.querySelectorAll('[data-mt-cuenta]');
    var els = [];
    for (var k = 0; k < todos.length; k++) {
      if (!todos[k].mtInit) {
        todos[k].mtInit = true;
        els.push(todos[k]);
      }
    }
    if (!els.length) return;

    function dos(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function poner(el, sel, valor) {
      var t = el.querySelector(sel);
      if (t && t.textContent !== valor) t.textContent = valor;
    }

    function pintar() {
      var ahora = Date.now();
      var vivos = 0;

      for (var i = 0; i < els.length; i++) {
        var el = els[i];

        if (el.mtFin === undefined) {
          /* "2026-08-22 23:59" -> fecha. Si no se entiende, se esconde. */
          var txt = (el.getAttribute('data-mt-cuenta') || '').trim().replace(' ', 'T');
          if (txt.length === 10) txt += 'T23:59';
          el.mtFin = Date.parse(txt);
        }

        if (isNaN(el.mtFin)) {
          el.hidden = true;
          continue;
        }

        el.hidden = false;
        var resto = el.mtFin - ahora;

        if (resto <= 0) {
          if (!el.classList.contains('mt-cuenta--fin')) {
            el.classList.add('mt-cuenta--fin');
            var fin = el.getAttribute('data-mt-fin') || '';
            var reloj = el.querySelector('.mt-cuenta__reloj');
            if (reloj) reloj.textContent = fin;
            var et = el.querySelector('.mt-cuenta__et');
            if (et && fin) et.remove();
          }
          continue;
        }

        vivos++;
        var s = Math.floor(resto / 1000);
        poner(el, '[data-d]', String(Math.floor(s / 86400)));
        poner(el, '[data-h]', dos(Math.floor((s % 86400) / 3600)));
        poner(el, '[data-m]', dos(Math.floor((s % 3600) / 60)));
        poner(el, '[data-s]', dos(s % 60));
      }

      /* Cuando ya no queda ninguna viva, dejamos de gastar reloj */
      if (!vivos && ventana) {
        clearInterval(ventana);
        ventana = null;
      }
    }

    var ventana = null;
    pintar();
    ventana = setInterval(pintar, 1000);

    /* Al volver a la pestaña, refrescamos por si el navegador paró el reloj */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) pintar();
    });
  }

  /* ------------------------------------------------- un solo oyente global */

  var tareas = [];
  var pedido = false;

  function engancharScroll(fn) {
    tareas.push(fn);
    if (pedido) return;
    pedido = true;
    var corriendo = false;
    function ciclo() {
      if (corriendo) return;
      corriendo = true;
      requestAnimationFrame(function () {
        for (var i = 0; i < tareas.length; i++) {
          try {
            tareas[i]();
          } catch (e) {}
        }
        corriendo = false;
      });
    }
    window.addEventListener('scroll', ciclo, { passive: true });
    window.addEventListener('resize', ciclo, { passive: true });
  }

  /* ------------------------------------------------------------- arranque */

  function arrancar() {
    escalonar();
    apariciones();
    contadores();
    escena();
    parallax();
    inclinar();
    acordeon();
    cabecera();
    galeria();
    variantes();
    cuentaAtras();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* El editor de Shopify recarga secciones sueltas: hay que rearmarlas */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(arrancar, 30);
  });
})();
